export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat("uk-UA", {
    style: "currency",
    currency: "UAH",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatPercentage = (value: number): string => {
  return `${Math.round(value)}%`;
};

export const formatRouteDetails = (route: {
  num?: string;
  name?: string;
  date?: string;
  time?: string;
}): string => {
  const parts = [];

  if (route.num) parts.push(`Рейс #${route.num}`);
  if (route.name) parts.push(route.name);
  if (route.date) parts.push(route.date);
  if (route.time) parts.push(route.time);

  return parts.join(" • ");
};
